import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import Loader from "../../../components/Loader";
import { ResumeDataService } from "../../../services/create-resume/resume-data";

const EmailAuthCallback = () => {
	const authCodeService = new ResumeDataService();

	const queryParams = new URLSearchParams(window.location.search);
	const code = queryParams.get("code");
	const error = queryParams.get("error");
	const isGmail = queryParams.get("provider") === "gmail";

	const navigate = useNavigate();

	useEffect(() => {
		const fetchAuthData = async () => {
			if (code) {
				navigate("/profile");
				await authCodeService.submitEmailAuthCode(
					code,
					isGmail ? "gmail" : "outlook",
					() => {
						toast.success(`Your ${isGmail ? "gmail" : "outlook"} email has been connected successfully.`);
						navigate("/profile");
					},
					() => {
						toast.error(`Connecting to ${isGmail ? "gmail" : "outlook"} account failed!`);
						navigate("/profile");
					},
				);
			}

			if (error) navigate("/profile");
		};

		fetchAuthData();
	}, []);

	return (
		<div className="flex items-center justify-center h-screen">
			<div className="text-blue">
				<Loader />
				<p className="text-2xl! mb-10 text-gray-700 font-inter text-center">
					{`Connecting to your ${isGmail ? "gmail" : "outlook"} account ....`}
				</p>
			</div>
		</div>
	);
};

export default EmailAuthCallback;
